import React from 'react';
import { Icon } from '../atoms';

/**
 * Status Message Molecule
 * A component for displaying success, error, warning, or info messages
 */
const StatusMessage = ({ 
  type = 'info',
  title,
  message,
  onClose,
  className = ""
}) => {
  const typeConfig = {
    success: {
      alertClass: 'alert-success',
      icon: '✅',
      iconColor: 'text-success'
    },
    error: {
      alertClass: 'alert-danger',
      icon: '❌',
      iconColor: 'text-danger'
    },
    warning: {
      alertClass: 'alert-warning',
      icon: '⚠️',
      iconColor: 'text-warning'
    },
    info: {
      alertClass: 'alert-info',
      icon: 'ℹ️',
      iconColor: 'text-info'
    }
  };

  const config = typeConfig[type] || typeConfig.info;

  return (
    <div className={`alert ${config.alertClass} ${onClose ? 'alert-dismissible' : ''} ${className}`} role="alert">
      <div className="d-flex align-items-start">
        <Icon 
          emoji={config.icon} 
          className="me-2 mt-1" 
          size="1.1rem"
        />
        <div className="flex-grow-1">
          {title && <strong className="d-block mb-1">{title}</strong>}
          <div>{message}</div>
        </div>
        {onClose && (
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        )}
      </div>
    </div>
  );
};

export default StatusMessage;
